import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import {
  Column,
  Row,
  Label,
  H3,
  H4,
  Footer,
  MainWrapper,
  Metadata,
  Spinner,
  RowToColumn,
  TweetHighlight,
  ListItem,
  AutoCompleteWithResponses,
  SubscribeBanner,
} from "../../components";
import { formatShortDates, getISOFormattedDateTimeString } from "../../utils";
import moment from "moment";
import {
  HeaderAndDrawer,
  // Share
} from "./components";

const StyledLink = styled(Link)`
  width: 100%;
  margin-top: -10px;
`;

export const view = ({
  signUpClick,
  isAdmin,
  conferences,
  loadingConferences,
  successConferences,

  tweet,
  isLoadingTweets,

  hashtags,
  hashtagsInfiniteScroll,
  hashtagTerm,
  setHashtagTerm,
  addSelectedHashtag,
}) => {
  return (
    <MainWrapper className="dashboard">
      <Metadata />
      <HeaderAndDrawer {...{ signUpClick, isAdmin }} />
      <Column marginTop="100">
        <Column paddingBottom="100">
          <Column center>
            <Column maxWidth="1200" paddingX gap="40">
              <Column>
                <H3 bold>Conference hashtags</H3>
              </Column>
              <RowToColumn gap="40" columnGap="40">
                <Column fit maxWidth="600" gap="20">
                  <AutoCompleteWithResponses
                    showOnEmptyTerm
                    searchResults={hashtags}
                    icon="search"
                    placeholder="Search hashtag"
                    searchTerm={hashtagTerm}
                    setSearchTerm={setHashtagTerm}
                    selectedItems={[]}
                    addItem={addSelectedHashtag}
                    // removeItem={removeSelectedTag}
                    clearSearchResults={() => {}}
                    searchLoading={false}
                    infiniteScroll={hashtagsInfiniteScroll}
                    hidePills
                    hasClearButton={hashtagTerm !== "#"}
                    showSuggestion
                    hasPages
                  />
                  {loadingConferences && (
                    <Row marginY="40" expand center>
                      <Spinner />
                    </Row>
                  )}
                  {successConferences && conferences?.length === 0 && (
                    <Row marginY="40" expand center>
                      <Label color="gray" fade="7">
                        No hashtags found!
                      </Label>
                    </Row>
                  )}
                  {conferences?.length > 0 && (
                    <Column gap="20" marginTop="40">
                      <H4 bold>Recent hashtags</H4>
                      {conferences?.map((conference) => (
                        <Row key={conference.id}>
                          <StyledLink
                            to={`/influencers/hashtag/${conference.tag.name?.replace(
                              "#",
                              ""
                            )}`}
                          >
                            <ListItem expand middle hover radius="20">
                              <Row gap="10" middle expand paddingY="6">
                                <Column gap="5">
                                  <H4 bold>{conference.tag.name}</H4>
                                  <Label color="gray" fade="7">
                                    {formatShortDates(
                                      getISOFormattedDateTimeString(
                                        moment(conference.startDate)?.utc()
                                      ),
                                      getISOFormattedDateTimeString(
                                        moment(conference.endDate)?.utc()
                                      )
                                    )}
                                  </Label>
                                </Column>
                                <Row fit />
                                <Label color="gray" fade="7" bold noShrink>
                                  {conference.tag.count}{" "}
                                  {conference.tag.count === 1
                                    ? "post"
                                    : "posts"}
                                </Label>
                              </Row>
                            </ListItem>
                          </StyledLink>
                        </Row>
                      ))}
                    </Column>
                  )}
                </Column>
                <Column maxWidth="560" gap="40">
                  {isLoadingTweets && (
                    <Row marginY="40" expand center>
                      <Spinner />
                    </Row>
                  )}
                  {tweet && (
                    <Link to={`/post/${tweet.externalId}`}>
                      <Column gap="5" marginBottom="20">
                        <Row>
                          <Row bkg="green" fade="1" paddingX="5" paddingY="3">
                            <Label small bold color="purple" fade="8">
                              TOP POST FROM {conferences?.[0]?.tag?.name}
                            </Label>
                          </Row>
                        </Row>
                        <Label large>
                          {tweet?.tAccount?.lastName &&
                            `Congratulations Dr. ${tweet.tAccount.lastName}. Keep up the good work!`}{" "}
                        </Label>
                      </Column>
                      <TweetHighlight data={tweet} />
                    </Link>
                  )}

                  <SubscribeBanner />
                </Column>
              </RowToColumn>
            </Column>
          </Column>
        </Column>
        <Footer />
      </Column>
    </MainWrapper>
  );
};
